import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import PaymentDrawyer from "./DrawyerPages/PaymentDrawyer";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const OverViewPayment: React.FC<any> = React.memo((props) => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getPaymentPermission;
  const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const [openF, setOpen] = React.useState(false);
  const id = params?.id;
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [resetLoad, setResetLoad] = useState(false)
  const [formComponent, setFormComponent] = useState<any>()
  const isMobile = IsSmallScreen();
  const [paymentData, setPaymentData] = useState<any>([])
    const resetTrigger = useSelector((state: any) => state.components?.paymentDealsGrid?.resetTrigger);
  const navigate = useNavigate();
  const columns: IColumns[] = [
    {
      header: "Date",
      fieldName: "paymentDate",
      tooltip: true,
      type: 'date'
    },
    {
      header: "Amount",
      fieldName: "amountReceived",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Method",
      fieldName: "paymentMethod",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined, "Thanks letter"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ]
  useEffect(() => {

    const getPayment = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI(`payment-receives/lead`, Method.GET, null, id);
        setPaymentData(response?.data);
      }


      catch (e) {

      }
    }
    getPayment();
  }, [resetLoad,resetTrigger])
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      const form: any = <PaymentDrawyer
        id="paymentrawyer"
        data={row}
        paymentId={row?.id}
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    } else if (action === "Delete") {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
    }
    else if (action === 'Thanks letter') {
      navigate(`/payment/thanks-letter/print/${row?.id}`);
    }
  }

  const handleDelete = async (id?: string | number) => {
    const response: any = await callAPI(`payment-receives`, Method.DELETE, null, id);
    dispatch(resetDataComponent('paymentDealsGrid'));
    setResetLoad(true)
    if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
    handleClose()

  };

  const handlePaymentData = async (data: any) => {
    try {
      dispatch(storeDataComponent('paymentSubmit', { loading: true }));
       setResetLoad(false)
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('paymentDealsGrid'));
        reset()
        setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('paymentDealsGrid'));
        setResetLoad(true)
        showMessage('Product Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      setResetLoad(false)
    }
    finally {
      dispatch(updateDataComponent('paymentSubmit', { loading: false }));
    }

  }
  const saveData = async (data: any) => {

    const request: any = {
      "leadId": id,
      "amountReceived": Number(data?.amountReceived),
      "paymentMethod": data?.paymentMethod,
      "transactionReference": data?.transactionReference,
      "notes": data?.notes,
      // workOrderId: id,
      invoiceNumber: data?.invoiceNumber,
      accountCode: ' ',

    }
    if (data?.paymentId) {

      const response: any = await callAPI(`payment-receives`, Method.PUT, request, data.paymentId);
      return response
    } else {
      const response: any = await callAPI("payment-receives", Method.POST, request);
      return response
    }
  }

  const handlePaymentClick = () => {
    setOpen(true)
    const form: any =
      <PaymentDrawyer
        id="paymentrawyer"
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false) }}
      />

    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }
  return (
    <Grid>
      <Grid container spacing={2} sx={{ marginTop: 0 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="paymentDealsGrid"
            title="Payments"
            columns={columns}
            data={paymentData}
            // addButton={add ? { label: "New", color: "secondary" } : undefined}
            // onAddButtonClick={handlePaymentClick}
            gridHeaderSx={{
              backgroundColor: "#004700",
              border: "1px solid #004700",

            }} isAccordian={true}
            addButtonBgClor={{ bg: '#004700', hovercolor: '#008000' }}
          />
        </Grid>
          : <PermissionDenied />
        }
      </Grid>
      <ConfirmDialog
        open={open}
        title={title}
        onConfirm={onConfirm}
        onClose={handleClose}
      />
      <SwipeableDrawerForm anchor="right" title={'Payments'}
        openForm={openF}
        formComponent={<form onSubmit={handleSubmit(handlePaymentData)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
    </Grid>
  );
});
